import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Table Tennis Rules and Regulations</h3>
              <h3>Playing Conditions</h3>
              <p>a. Common Rules</p>
              <p>• The balls used will be 3-star Stiga balls.</p>
              <p>
                • Each team can have a maximum of 6 players, consisting of 3
                males and 3 females.
              </p>
              <p>
                • The match formats include Men's Singles, Women's Singles,
                Men's Doubles, and Women's Doubles.
              </p>
              <p>
                • Mixed teams, comprising both male and female players, are
                allowed.
              </p>
              <p>• The League Matches would be of 3 Sets of 11 Points each</p>
              <p>• The knockout matches would be of 5 Sets of 11 Points each</p>
              <p>
                • The Partners once played together a mtach cannot be changed in
                any condition whatsoever
              </p>
              <p>
                • All other Standard TTFI &amp; ITTF rules will be applicable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
